/* global Office */

const getMailbox = () => {
  try {
    return Office.context?.mailbox || null;
  } catch {
    return null;
  }
};

const isSucceeded = (result) => {
  try {
    return result?.status === "succeeded" || result?.status === Office.AsyncResultStatus?.Succeeded;
  } catch {
    return result?.status === "succeeded";
  }
};

export const getOutlookUserProfile = () => {
  const mailbox = getMailbox();

  return {
    userEmail: mailbox?.userProfile?.emailAddress || "",
    userName: mailbox?.userProfile?.displayName || "",
  };
};

/**
 * Resolves the mailbox that owns the current item. For a personal mailbox this
 * is the signed-in user. For a shared/delegated mailbox, Outlook supplies the
 * mailbox owner and target mailbox through getSharedPropertiesAsync.
 */
export const getOutlookItemContext = async (item = getMailbox()?.item) => {
  const { userEmail: actorEmail, userName: actorName } = getOutlookUserProfile();
  const context = {
    messageId: item?.internetMessageId || item?.itemId || "",
    // Existing API payloads use userEmail to identify the mailbox being processed.
    userEmail: actorEmail,
    actorEmail,
    actorName,
    mailboxOwner: "",
    targetMailbox: "",
    isSharedContext: false,
  };

  let supportsSharedMailbox = false;

  try {
    supportsSharedMailbox = Office.context?.requirements?.isSetSupported?.("Mailbox", "1.13");
  } catch {
    supportsSharedMailbox = false;
  }

  if (!item?.getSharedPropertiesAsync || !supportsSharedMailbox) {
    return context;
  }

  try {
    const result = await new Promise((resolve) => {
      item.getSharedPropertiesAsync(resolve);
    });

    if (!isSucceeded(result) || !result.value) {
      return context;
    }

    const mailboxOwner = result.value.owner || "";
    const targetMailbox = result.value.targetMailbox || "";

    if (!mailboxOwner && !targetMailbox) {
      return context;
    }

    return {
      ...context,
      userEmail: mailboxOwner || actorEmail,
      mailboxOwner,
      targetMailbox,
      isSharedContext: true,
    };
  } catch {
    // Outlook returns an expected error for a non-shared item. The personal
    // mailbox context above remains the correct fallback in that case.
    return context;
  }
};
